import { render } from "./InvitationConfirm.vue?vue&type=template&id=bde536c8"
import script from "./InvitationConfirm.vue?vue&type=script&lang=js"
export * from "./InvitationConfirm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Xoan\\asp-user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__